package one.healthium.domain.health_log.models

import kotlinx.serialization.Serializable

@Serializable
data class HealthLogQuestionModel(
    val id: String,
    val kind: String,
    val question: String? = null,
    val answers: List<HealthLogAnswerModel>,
) {
    companion object {
        val preview = HealthLogQuestionModel(
            id = "1",
            kind = "Mood",
            question = "How are you feeling today?",
            answers = listOf(
                HealthLogAnswerModel(id = "1", weight = 1, text = "Happy"),
                HealthLogAnswerModel(id = "2", weight = 2, text = "Sad"),
                HealthLogAnswerModel(id = "3", weight = 3, text = "Neutral"),
            )
        )
    }
}

@Serializable
data class HealthLogAnswerModel(
    val id: String,
    val weight: Int,
    val text: String,
)